<template>
  <div class="communityCenter">
    <div class="listWrap">
      <Scroller
        :is-refresh-data.sync="refresh"
        :is-loading-data.sync="loading"
        :is-finished-data.sync="finished"
        :no-data-text-data.sync="noDataText"
        :is-disabled-data="disabledload"
        @on-infinite="onInfinite"
        @on-refresh="onRefresh"
        class="my_scroller"
        ref="my_scroller"
      >
        <div
          class="headerInfo"
          :style="
            info.bgimgurl
              ? { 'background-image': 'url(' + info.bgimgurl + ')' }
              : { 'background-image': 'url(/static/images/community/new-img/bg@2x.png)' }
          "
        >
          <div class="flex-ac">
            <div class="headLogo" v-if="authorid">
              <head-pendant :identity="info.identity">
                <img
                  v-if="head"
                  :src="head"
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorHeadImg
                      img.onerror = null
                    }
                  "
                />
                <img v-if="!head" :src="errorHeadImg" />
              </head-pendant>
            </div>
            <div class="headLogo" v-else>
              <head-pendant :identity="info.identity">
                <img
                  :src="head"
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorHeadImg
                      img.onerror = null
                    }
                  "
                />
              </head-pendant>
              <vue-crop-avatar
                :isRound="false"
                :maxCropWidth="1000"
                :maxCropHeight="1000"
                :cropBoxBorderColor="`#666`"
                :defaultImgPath="head"
                @getrawdata="getCanvasData"
                @fileuploaderr="fileuploaderr"
                :beforeClose="closemodal"
                outputType="image/png"
              ></vue-crop-avatar>
            </div>
            <div>
              <p class="nickName flex-ac f18">
                <span>{{ name }}</span>
                <img
                  v-if="!authorid"
                  class="editor"
                  @click="isrealname = true"
                  src="/static/images/community/new-img/editor.png"
                />
                <img
                  v-if="info.authorlevel && info.authorlevel != 0"
                  class="viptag"
                  :src="$getVipLevel(info.authorlevel)"
                />
              </p>
              <p
                class="certification flex-ac f12"
                v-if="
                  !authorid &&
                    (info.verstatus == 0 ||
                      info.verstatus == 1 ||
                      info.verstatus == 2 ||
                      info.verstatus == 3)
                "
              >
                <img src="/static/images/community/new-img/safetycert.png" />
                {{
                  info.verstatus == 0
                    ? '暂未认证，'
                    : info.verstatus == 1
                    ? info.vertag
                    : info.verstatus == 2
                    ? '认证审核中'
                    : info.verstatus == 3
                    ? '资料审核失败'
                    : ''
                }}
                <span
                  :style="
                    info.verstatus == 3 ? { color: '#FF0101', 'text-decoration': 'none' } : {}
                  "
                  v-if="!authorid && (info.verstatus == 0 || info.verstatus == 3)"
                  @click="goCertification"
                >
                  {{ info.verstatus == 3 ? '查看原因>' : '去认证' }}
                </span>
                <span
                  style="color: #338BF6;text-decoration: none"
                  v-if="info.verstatus == 1"
                  @click="description"
                >
                  （信用分{{ info.creditscore }}）
                </span>
              </p>
              <p class="certification flex-ac f12" v-else-if="info.vertag">
                <img src="/static/images/community/new-img/safetycert.png" />
                {{ info.vertag }}
              </p>
            </div>
          </div>
          <div class="btn">
            <p
              v-if="authorid"
              class="follow"
              :class="{ greybor: info.isfollow != 0 }"
              @click="switchFollow(0, info.isfollow, authorid)"
            >
              {{ info.isfollow == 0 ? '关注' : '取消关注' }}
            </p>
            <van-uploader
              v-else
              v-model="updatebg"
              accept="image"
              preview-size="0"
              :deletable="false"
              :after-read="afterRead"
            >
              <p class="follow grey flex-jc-ac">
                <img src="/static/images/community/new-img/updatebg.png" />
                更换背景
              </p>
            </van-uploader>
          </div>
          <!--          <div class="flex-ac" v-if="info.level > 0 || info.identity > 0" style="margin-top: 0.14rem;">-->
          <!--            <van-tag v-if="info.level > 0" round type="primary" color="#333333" text-color="#FEE784">分享官V{{info.level}}</van-tag>-->
          <!--            <div v-if="info.level > 0">&nbsp;&nbsp;</div>-->
          <!--            <van-tag v-if="info.identity == 1" round type="primary" color="#333333" text-color="#FEE784">官方讲师</van-tag>-->
          <!--            <div v-if="info.identity == 1">&nbsp;&nbsp;</div>-->
          <!--            <van-tag v-if="info.identity == 2" round type="primary" color="#333333" text-color="#FEE784">智囊团</van-tag>-->
          <!--          </div>-->
          <div class="flex-ac mt22 f14" style="color: #ffffff;">
            <p class="mr16" @click="goFans(0)">
              <span class="f16 fb">{{ info.follownum }}</span>
              <span style="color: rgba(255, 255, 255, .76)">关注</span>
            </p>
            <p class="mr16" @click="goFans(1)">
              <span class="f16 fb">{{ info.fansnum }}</span>
              <span style="color: rgba(255, 255, 255, .76)">粉丝</span>
            </p>
            <p>
              <span class="f16 fb">{{ info.likesnum }}</span>
              <span style="color: rgba(255, 255, 255, .76)">获赞/收藏</span>
            </p>
          </div>
          <div
            v-if="!authorid"
            @click="goUpdate"
            class="nickName selfintroduction f12 flex"
            style="color:#ffffff;font-weight: normal;margin-top: 0.1rem"
            v-html="
              ($store.state.updateIntroduce
                ? $store.state.updateIntroduce.replace(/\n/g, '<br/>')
                : '点击添加自我介绍') +
                '<img class=editor style=margin-left:0.04rem;width:0.14rem;height:0.14rem;margin-top:0.07rem; src=/static/images/community/new-img/editor.png>'
            "
          ></div>
          <div
            v-else-if="info.selfintroduction"
            class="nickName selfintroduction f12 flex-ac"
            style="color:#ffffff;font-weight: normal;margin-top: 0.1rem"
            v-html="info.selfintroduction.replace(/\n/g, '<br/>')"
          ></div>
        </div>
        <div class="tab flex-js-ac">
          <p
            :class="currentIndex == index ? 'active' : ''"
            v-for="(item, index) in tab"
            @click="changeTab(index)"
          >
            {{ item }}
          </p>
        </div>
        <div v-if="currentIndex == 0" class="list">
          <div v-if="!authorid" class="item draft" @click="goDraft">
            <img src="/static/images/community/floorplan@2x.png?v=1" />
            <div>
              <img width="24" height="24" src="/static/images/community/draft@2x.png" />
              <p class="f14">草稿箱</p>
              <span class="f11">{{ info.draftnum }}个草稿</span>
            </div>
          </div>
          <div class="item" v-for="(item, index) in list" :key="item.id" @click="goDetail(item)">
            <div class="logo">
              <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start -->
              <img
                v-lazy="
                  item.coverimg +
                    ($cos.isCosSwitch == 1
                      ? $cos.pathSymbol(item.coverimg) + $cos.imageLinkParamsStr
                      : '?x-oss-process=image/format,jpg')
                "
              />
              <!-- 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End -->
              <img
                v-if="item.isvideo == 1"
                class="isvideo"
                src="/static/images/community/video2.png"
              />
              <star :star="item.star">
                <slot v-if="!authorid">
                  <img
                    class="delimg"
                    src="/static/images/community/topgray.png"
                    v-if="item.istop != 1"
                    @click.stop="top(item, index)"
                  />
                  <img
                    class="delimg"
                    src="/static/images/community/notopgray.png"
                    v-else
                    @click.stop="top(item, index)"
                  />
                  <img
                    class="delimg"
                    src="/static/images/community/editgray.png"
                    @click.stop="update(item, index)"
                  />
                  <img
                    class="delimg"
                    src="/static/images/community/delgray.png"
                    @click.stop="del(item, index)"
                  />
                </slot>
              </star>
            </div>
            <!--            <img v-if="item.istop == 1" class="isvideo top" src="/static/images/community/top.png">-->
            <div class="desWrap">
              <p class="name over-ell-1 f16" style="font-weight: bold">{{ item.title }}</p>
              <p class="name over-ell-2 f14">{{ item.content }}</p>
              <div class="bottom12" v-if="currentIndex == 0">
                <p class="statusWrap orange" v-if="item.status == 0">审核中</p>
                <p
                  class="statusWrap red flex-ac"
                  v-else-if="item.status == 2"
                  @click.stop="showReject(item)"
                >
                  <span>已驳回</span>
                  <img class="rejectTips" src="/static/images/community/rejectTips.png" />
                </p>
                <div class="flex-ac btn" v-else>
                  <p class="flex-ac">
                    <img src="/static/images/community/love.png" />
                    <span class="num">{{ item.praisenum }}</span>
                  </p>
                  <p class="flex-ac">
                    <img src="/static/images/community/comment.png" />
                    <span class="num">{{ item.commentnum }}</span>
                  </p>
                  <p class="flex-ac">
                    <img src="/static/images/community/collection.png" />
                    <span class="num">{{ item.collectionnum }}</span>
                  </p>
                </div>
              </div>
              <div class="mt12 flex-js-ac" v-else>
                <div class="flex-ac">
                  <img
                    class="authorHead"
                    :src="item.authorhead"
                    @error="
                      (event) => {
                        let img = event.srcElement
                        img.src = errorHeadImg
                        img.onerror = null
                      }
                    "
                  />
                  <p class="authorName f10">{{ item.authorname }}</p>
                </div>
                <div
                  v-if="item.ismyself != 1"
                  :class="[item.isfollow == 0 ? 'red' : 'grey', 'follow f10']"
                  @click.stop="switchFollow(1, item.isfollow, item.authorid, index)"
                >
                  {{ item.isfollow == 0 ? '关注' : '取消关注' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="currentIndex == 1" class="list list1">
          <community-detail-item
            v-for="(item, index) of list1"
            class="listitem"
            :detailItem="item"
            :key="index"
            :markPointData="{ scenepoint: 'COMMUNITYMEPOST', scenedesc: item.itemid }"
          ></community-detail-item>
        </div>
        <div v-else-if="currentIndex == 2" class="list list1">
          <community-detail-item
            v-for="(item, index) of list2"
            class="listitem"
            :detailItem="item"
            :key="index"
            :markPointData="{ scenepoint: 'COMMUNITYMEPOST', scenedesc: item.itemid }"
          ></community-detail-item>
        </div>
      </Scroller>
      <div
        class="noData"
        v-if="(empty && currentIndex != 0 && !authorid) || (empty && authorid)"
        :style="{ height: emptyHeight / 100 + 'rem', padding: '0.1rem 0.11rem' }"
      >
        <img src="../../assets/images/emptyorder.png" />
        <p v-if="currentIndex == 0" @click="goRelease">去发点有趣的事></p>
        <p v-else @click="goCommunity">去社区逛逛>></p>
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="newperson && newperson.isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <van-dialog
      v-model="isrealname"
      title="编辑昵称"
      show-cancel-button
      cancel-button-color="#fc0324"
      confirm-button-text="保存"
      :before-close="(action, done) => done(false)"
      @cancel="isrealname = false"
      @confirm="confirm"
      class="signin_button_alert collect_button_alert"
    >
      <ul>
        <li class="flex">
          <input type="text" maxlength="15" v-model="realname" placeholder="请输入昵称" />
          <img
            class="del-btn"
            src="/static/wx/img/close3.png"
            v-if="realname"
            @click="realname = ''"
          />
          <p class="f11 color-9">&nbsp;{{ realname.length }}/15</p>
        </li>
        <p class="f11 color-9" style="margin-top: 0.06rem">请输入1-15个字符，不包括特殊字符哦</p>
      </ul>
    </van-dialog>
  </div>
</template>

<script>
import communityDetailItem from '../common/communityDetailItem'
import { isWeixin, fenxiang, cosaccesspath } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import Star from '../common/star'
import headPendant from '../common/headPendant'
import { Tag } from 'vant'
import '../../../static/wx/css/mobilePop.css'
import VueCropAvatar from 'vue-crop-avatar'

export default {
  name: 'communityCenter',
  components: {
    communityDetailItem,
    VueCropAvatar,
    Scroller,
    Star,
    headPendant,
    [Tag.name]: Tag
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    newperson: Object
  },
  data() {
    return {
      currentIndex: this.$store.state.communityCenterTab ? this.$store.state.communityCenterTab : 0, // 当前tab索引
      refresh: false,
      loading: false,
      disabledload: false,
      finished: false,
      nowPage: 0,
      pagesize: 10,
      noDataText: '',
      tab: [],
      info: {
        follownum: '',
        fansnum: '',
        isfollow: '', // 0/1 否/是
        draftnum: ''
      },
      head: '',
      name: '',
      list: [],
      list1: [],
      list2: [],
      authorid: null, // 作者id
      empty: false,
      editFlag: false,
      emptyHeight: 0,
      updatebg: [],
      fileLen: 0,
      datalist: [],
      isrealname: false,
      realname: ''
    }
  },
  watch: {
    updatebg(n) {
      if (n.length > 1) {
        this.updatebg.splice(0, 1)
      }
    }
  },
  created() {
    this.authorid = this.$route.query.authorid ? this.$route.query.authorid : null
    if (!this.authorid) {
      this.tab = ['作品', '点赞', '收藏', '数据']
    } else {
      this.tab = ['作品', '点赞', '收藏']
    }
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) {
      // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next((vm) => {
        if (isWeixin() && vm.type != 'comp') fenxiang({ path: 'communitycenter' })
        vm.authorid = vm.$route.query.authorid ? vm.$route.query.authorid : null
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.empty = false
        if (!vm.authorid && to.path != '/communitycenter') {
          vm.currentIndex = vm.$store.state.communityCenterTab
        } else {
          vm.currentIndex = 0
        }
        if (vm.type != 'comp') vm.getMain()
        vm.nowPage = 0
        vm.list = []
        vm.list1 = []
        vm.list2 = []
      })
    } else {
      next((vm) => {
        if (isWeixin() && vm.type != 'comp') fenxiang({ path: 'communitycenter' })
        vm.authorid = vm.$route.query.authorid ? vm.$route.query.authorid : null
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        if (!vm.authorid && to.path != '/communitycenter') {
          vm.currentIndex = vm.$store.state.communityCenterTab
        } else {
          vm.currentIndex = 0
        }
        if (vm.type != 'comp') vm.getMain()
        vm.empty = false
        vm.nowPage = 0
        vm.list = []
        vm.list1 = []
        vm.list2 = []
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    this.loading = true
    next()
  },
  methods: {
    newpersontask() {
      window.location = this.newperson.newpersonjump
    },
    goCertification: function() {
      if (this.info.verstatus == 0) {
        window.location = '/static/wx/html/community-creator/creator.html'
      } else {
        this.$router.push('/certification?verstatus=' + this.info.verstatus)
      }
    },
    closemodal: function() {
      this.disabledload = false
    },
    fileuploaderr: function() {
      this.disabledload = true
    },
    getCanvasData: function(canvas) {
      this.disabledload = false
      var imgSrc = canvas.toDataURL('image/png')
      var imgName = 'communityheadimg'
      var blob = this.dataURLtoBlob(imgSrc)
      var file = this.blobToFile(blob, imgName)
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
      this[this.$cos.isCosSwitch == 1 ? 'cosUploadHead' : 'uploadHead'](file)
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
      console.log(file)
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadHead(file) {
      console.log(file)
      var that = this
      that.$toast.loading({
        duration: 0,
        message: '正在上传，请稍后...',
        forbidClick: true
      })
      that.$cos.uploadFile({
        key: '/communitycenter_h5' + file.name + '.jpg',
        file: file,
        success: function(data) {
          that.$ckeckgraphic({
            content: '',
            images: data,
            callback: () => {
              that.head = cosaccesspath + data
              that.editInfo()
            }
          })
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadHead: async function(imgFile) {
      // let OSS = require('ali-oss');
      const url = this.$ajax.getOssWeb_URL
      var that = this
      that.$toast.loading({
        duration: 0,
        message: '正在上传，请稍后...',
        forbidClick: true
      })
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + imgFile.name + '.' + 'png'
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', imgFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status === 200 && res.statusText == 'OK') {
              that.$ckeckgraphic({
                content: '',
                images: that.ossImgUrl + `${dir}${str}`,
                callback: () => {
                  that.head = that.ossImgUrl + `${dir}${str}`
                  that.editInfo()
                }
              })
            }
          })
        }
      })
    },
    confirm: function() {
      if (this.realname.trim() == '') {
        this.$toast('保存的昵称为空，请重新输入')
        return
      }
      this.editInfo('name')
    },
    goUpdate: function() {
      if (this.info.selfintroduction) {
        this.$store.commit('UPDATE_INTRODUCE', this.info.selfintroduction)
      }
      this.$router.push('/updateintroduce?verstatus=' + this.info.verstatus)
    },
    afterRead: function() {
      var that = this
      that.fileLen = 0
      that.datalist = []
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
      that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
        that.updatebg,
        that.updatebg[that.fileLen],
        that.fileLen,
        '.png',
        'imgpath',
        function() {
          that.$ckeckgraphic({
            images: that.datalist[0],
            callback: () => {
              that.submitAxios()
            }
          })
        }
      )
      // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    },
    submitAxios: function() {
      var url = this.$ajax.updateMainInfo_URL,
        data = {
          bgimg: this.datalist[0]
        },
        that = this
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
          that.info.bgimgurl =
            that.$cos.isCosSwitch == 1
              ? cosaccesspath + that.datalist[0]
              : that.ossImgUrl + 'Uploads/' + that.datalist[0]
          // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function(n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(filllist, file, index, format, type, fn) {
      console.log(file)
      var that = this
      that.$cos.uploadFile({
        key: '/communitycenter_h5' + file.file.name,
        file: file.file,
        success: function(data) {
          if (type == 'imgpath') {
            that.datalist.push(data)
            console.log(that.updatebg)
          }
          index++
          if (index >= filllist.length) {
            if (typeof fn === 'function') {
              fn()
            }
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(filllist, file, index, format, type, fn) {
      var imgName = 'communitybg'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      var url = this.$ajax.getOssWeb_URL
      var that = this
      this.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + format
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.imgUrl + `${dir}${str}`
              var path = `${dir}${str}`.replace('Uploads/', '')
              if (type == 'imgpath') {
                that.datalist.push(path)
                console.log(that.updatebg)
              }
              index++
              if (index >= filllist.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              }
            }
          })
        }
      })
    },
    goRelease: function() {
      var that = this
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'communityCenter'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f() {
        that.$router.push({
          path: '/communityevaluation'
        })
      }
    },
    goCommunity: function() {
      this.$store.commit('COMMUNITY_TAB', 1)
      if (!this.authorid) {
        this.$router.go()
      } else {
        this.$router.push({
          path: '/community'
        })
      }
    },
    goDetail(item) {
      var id = item.itemid
      if (this.currentIndex == 0 && item.status == 2) {
        this.$router.push({
          path: '/communityevaluation',
          query: {
            id: id
          }
        })
      } else if ((this.currentIndex == 0 && item.status != 0) || this.currentIndex != 0) {
        this.$router.push({
          path: '/communitydetail',
          query: {
            id: id
          }
        })
      }

      // this.$router.go()
      // window.location.href = '/productdetail?itemid=' + id
    },
    goFans: function(type) {
      var queryata = {
        type: type
      }
      if (this.authorid) queryata.authorid = this.authorid
      this.$router.push({
        path: '/fanslist',
        query: queryata
      })
    },
    // 修改头像、昵称
    editInfo(type) {
      let url = this.$ajax.modifyUser_URL,
        params = {}
      if (type == 'name') {
        params.smallname = this.realname
      } else {
        params.head = this.head.replace(cosaccesspath, '')
      }
      this.$customRequestAjax.post(url, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 'name') {
            this.isrealname = false
            this.name = this.realname
          } else if (type != 'name') {
            this.$toast({
              message: '上传成功',
              icon: require('../../assets/images/succ.png')
            })
          }
        } else {
          this.$toast(res.data.msg)
        }
      })
    },
    // 切换tab
    changeTab(index) {
      if (index != this.currentIndex && index != 3) {
        this.nowPage = 0
        this.empty = false
        this.currentIndex = index
        if (!this.authorid) this.$store.commit('COMMUNITY_CENTER_TAB', this.currentIndex)
        this.onInfinite()
      } else if (index == 3) {
        this.$router.push('/datacenter')
      }
    },
    goDraft: function() {
      this.$router.push({
        path: '/draftList'
      })
    },
    getMain: function() {
      let url = '',
        community_me_info = !this.authorid
          ? localStorage.getItem('community_me_info')
            ? JSON.parse(localStorage.getItem('community_me_info'))
            : null
          : null
      url =
        this.$ajax.getMain_URL +
        '?authorid=' +
        (this.$route.query.authorid ? this.$route.query.authorid : '')
      if (!this.$route.query.authorid) url += '&fromway=1'
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.info = res.data.data
          if (this.info.selfintroduction && !this.authorid) {
            this.$store.commit('UPDATE_INTRODUCE', this.info.selfintroduction)
          }
          this.name = res.data.data.name
          this.head = res.data.data.head
          community_me_info = {
            name: this.name,
            head: this.head,
            bgimgurl: this.info.bgimgurl
          }
          if (!this.authorid)
            localStorage.setItem('community_me_info', JSON.stringify(community_me_info))
          this.$nextTick(() => {
            setTimeout(() => {
              var tipsHeight = 0
              if (document.getElementsByClassName('tips').length > 0) {
                tipsHeight = document.getElementsByClassName('tips')[0].clientHeight
              }
              this.emptyHeight =
                document.body.clientHeight -
                document.getElementsByClassName('headerInfo')[0].clientHeight -
                document.getElementsByClassName('tab')[0].clientHeight -
                tipsHeight -
                20
            }, 0)
          })
        }
      })
    },
    // 获取列表数据
    getList() {
      let url = ''

      if (this.currentIndex != 0) {
        let type = this.currentIndex == 1 ? 1 : 0
        url =
          this.$ajax.getCollectionList_Community_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&type=' +
          type
      } else {
        url =
          this.$ajax.getMainPostsList_URL +
          '?authorid=' +
          (this.$route.query.authorid ? this.$route.query.authorid : '') +
          '&pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize
      }
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          let list = []
          if (this.currentIndex == 0) {
            list = res.data.data.publishlist
          } else {
            list = res.data.itemlist
          }
          if (this.nowPage === 1) {
            if (this.currentIndex == 0) this.list = list
            if (this.currentIndex == 1) this.list1 = list
            if (this.currentIndex == 2) this.list2 = list
            this.refresh = false
          } else {
            if (this.currentIndex == 0) this.list = this.list.concat(list)
            if (this.currentIndex == 1) this.list1 = this.list1.concat(list)
            if (this.currentIndex == 2) this.list2 = this.list2.concat(list)
          }
          this.loading = false
          this.finished = list.length < this.pagesize
          if (this.currentIndex == 0) {
            if (this.list.length <= 0) {
              this.empty = true
            }
          }
          if (this.currentIndex == 1) {
            if (this.list1.length <= 0) {
              this.empty = true
            }
          }
          if (this.currentIndex == 2) {
            if (this.list2.length <= 0) {
              this.empty = true
            }
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.getList()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      this.nowPage++
      this.getList()
    },
    // 驳回理由
    showReject(item) {
      this.$dialog
        .alert({
          title: '驳回理由',
          message: item.reason,
          className: 'percen_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(() => {})
        .catch(() => {})
    },
    // 删除
    del(item, index) {
      var that = this
      that.$dialog
        .confirm({
          message: '确定删除该内容吗？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '确认',
          closeOnPopstate: false,
          showCancelButton: true,
          cancelButtonText: '取消'
        })
        .then(() => {
          let url = that.$ajax.deletePosts_URL,
            params = {
              itemid: item.itemid
            }
          that.$customRequestAjax.post(url, params).then((res) => {
            if (res.data.code == 200) {
              that.list.splice(index, 1)
              if (that.list.length <= 0) {
                that.empty = true
              }
            } else {
              that.$toast(res.data.msg)
            }
          })
        })
        .catch(() => {})
    },
    top(item, index) {
      var url = this.$ajax.setMePostsTop_URL,
        data = {
          itemid: item.itemid,
          istop: item.istop == 1 ? 0 : 1
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.nowPage = 0
          this.empty = false
          this.onInfinite()
        }
      })
    },
    update(item, index) {
      this.$router.push({
        path: '/communityevaluation',
        query: {
          id: item.itemid,
          issue: 1
        }
      })
    },
    description: function() {
      window.location = '/static/wx/html/community-creator/description.html'
    },
    // 关注/取消关注
    switchFollow(type, isfollow, authorid, index) {
      if (isfollow) {
        this.$dialog
          .alert({
            message: '确认取消关注吗？',
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '确认',
            closeOnPopstate: false,
            showCancelButton: true,
            cancelButtonText: '取消'
          })
          .then(() => {
            this.submitFollow(type, isfollow, authorid, index)
          })
          .catch(() => {})
      } else {
        this.submitFollow(type, isfollow, authorid, index)
      }
    },
    submitFollow(type, isfollow, authorid, index) {
      let url = this.$ajax.community_follow_URL,
        params = {
          isfollow: isfollow == 1 ? 0 : 1,
          authorid: authorid
        }
      this.$customRequestAjax.post(url, params).then((res) => {
        if (res.data.code == 200) {
          if (type) {
            this.list[index].isfollow = isfollow == 0 ? 1 : 0

            console.log(this.list)
          } else {
            this.info.isfollow = isfollow == 0 ? 1 : 0
          }
        } else {
          this.$toast(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.communityCenter {
  font-size: 0.13rem;
  .headerInfo {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 1.74rem;
    padding: 0.16rem;
    padding-top: 0.46rem;
    color: #222;
    position: relative;
    /*border-radius: 0 0 0.2rem 0.2rem;*/
    .mr16 {
      margin-right: 0.16rem;
    }
    .headLogo {
      width: 0.69rem;
      height: 0.69rem;
      margin-right: 0.15rem;
      position: relative;
      img {
        width: 0.69rem;
        height: 0.69rem;
        border-radius: 0.35rem;
        object-fit: cover;
      }
    }
    .edit {
      margin-left: 0.04rem;
      width: 0.16rem;
      height: 0.16rem;
    }
    .nickName {
      margin-right: 0.15rem;
      line-height: 0.28rem;
      color: #ffffff;
      font-weight: bold;
      word-break: break-all;
      &.selfintroduction {
        line-height: 0.18rem;
      }
      input {
        border: none;
        width: 1rem;
        background: none;
      }
      .editor {
        margin-left: 0.04rem;
        width: 0.14rem;
        height: 0.14rem;
      }
      .viptag {
        margin-left: 0.06rem;
        /*width: 0.23rem;*/
        height: 0.23rem;
      }
    }
    .btn {
      position: absolute;
      right: 0.1rem;
      top: 0.8rem;
    }
    .certification {
      color: #ffffff;
      margin-top: 0.07rem;
      img {
        width: 0.13rem;
        height: 0.13rem;
        margin-right: 0.02rem;
      }
      span {
        text-decoration: underline;
      }
    }
    .follow {
      margin-top: 0.05rem;
      width: 0.9rem;
      line-height: 0.28rem;
      background-image: linear-gradient(to right, #fc0324, #fc5f80);
      text-align: center;
      border-radius: 0.16rem;
      font-size: 0.14rem;
      color: #fff;
      &.red {
        border: 1px solid #fc0324;
        color: #fc0324;
        background: transparent;
        line-height: 0.26rem;
      }
      &.greybor {
        border: 1px solid #ffffff;
        color: #ffffff;
        background: transparent;
        line-height: 0.26rem;
      }
      &.grey {
        img {
          width: 0.12rem;
          height: 0.12rem;
          margin-right: 0.04rem;
        }
        color: #ffffff;
        background: rgba(0, 0, 0, 0.08);
        line-height: 0.26rem;
      }
    }
    .mt17 {
      margin-top: 0.17rem;
    }
    .mt22 {
      margin-top: 0.22rem;
    }
  }
  .listWrap {
    .tab {
      padding: 0.16rem 0.48rem 0.1rem;
      color: #666;
      font-size: 0.14rem;
      .active {
        font-size: 0.15rem;
        font-weight: bold;
        color: #292929;
        border-bottom: 0.03rem solid#FC0728;
      }
    }
    .tips {
      margin: 0 0.11rem 0.1rem;
      padding: 0 0.1rem;
      height: 0.48rem;
      background: #fff;
      p {
        color: #666;
      }
      img {
        width: 0.15rem;
        height: 0.15rem;
      }
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 0 0.07rem;
      &.list1 {
        padding: 0 0.11rem;
      }
      .item.draft {
        position: relative;
        > img {
          width: 100%;
          height: 100%;
        }
        div {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          img {
            margin: 0 auto;
          }
          p {
            margin: 0.06rem 0;
          }
        }
      }
      .item {
        width: 50%;
        height: 2.74rem;
        padding: 0.05rem 0.04rem;
        position: relative;
        .logo {
          width: 100%;
          background: #fff;
          height: 1.67rem;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          border-radius: 0.04rem 0.04rem 0 0;
          img {
            width: 100%;
            height: auto;
          }
          .delimg {
            width: 0.28rem;
            height: 0.28rem;
            margin-left: 80%;
            margin-bottom: 0.06rem;
          }
        }
        .top {
          left: 0.01rem;
          top: 0.09rem;
        }
        .desWrap {
          height: 0.97rem;
          padding: 0.08rem 0.1rem 0.22rem;
          background: #fff;
          border-radius: 0 0 0.04rem 0.04rem;
          box-sizing: border-box;
          position: relative;
          .mt12 {
            margin-top: 0.12rem;
          }
          .bottom12 {
            position: absolute;
            left: 0.1rem;
            right: 0.1rem;
            bottom: 0.05rem;
          }
          .statusWrap {
            font-size: 0.14rem;
            &.orange {
              font-weight: bold;
              color: #ff8851;
            }
            &.red {
              font-weight: bold;
              color: #fc0324;
            }
          }
          .num {
            font-size: 0.1rem;
            color: #969696;
          }
          .rejectTips {
            margin-left: 0.02rem;
            width: 0.12rem;
            height: 0.12rem;
          }
        }
        img {
          width: 0.14rem;
          height: 0.14rem;
        }
        .btn {
          justify-content: space-between;
          .num {
            margin-left: 0.04rem;
          }
        }
        .authorHead {
          margin-right: 0.05rem;
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 0.1rem;
        }
        .authorName {
          width: 0.6rem;
          color: #292929;
          font-size: 0.12rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .follow {
          width: 0.64rem;
          height: 0.2rem;
          line-height: 0.2rem;
          border-radius: 0.1rem;
          text-align: center;
          &.red {
            border: 1px solid #fc0324;
            color: #fc0324;
          }
          &.grey {
            border: 1px solid #afb0af;
            color: #999;
          }
        }
      }
      .listitem {
        margin-top: 0.1rem;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .noData {
    margin: 0 0.1rem 0.11rem;
    /*padding: 0.7rem 1.14rem;*/
    background: #fff;
    text-align: center;
    font-size: 0.14rem;
    color: #fc0324;
    border-radius: 0.04rem;
    img {
      margin: 0 auto 0.16rem;
      width: 1.1rem;
      height: 1.1rem;
    }
  }
}
</style>
<style lang="scss">
.headerInfo {
  .van-tag--primary {
    border: 0.01rem solid #fee784;
    padding: 0.01rem 0.12rem;
  }
  .avatar-box {
    width: 0.69rem !important;
    height: 0.69rem !important;
    border-radius: 50% !important;
    overflow: hidden !important;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .modal .btn {
    background: none !important;
    border: none !important;
    outline: none !important;
    font-size: 0.16rem !important;
    font-family: 'PingFangSC' !important;
    font-weight: 400 !important;
    color: #fff !important;
    line-height: 0.22rem !important;
    position: absolute !important;
    right: 0.2rem !important;
    bottom: 0.2rem !important;
  }
  .close {
    position: absolute !important;
    top: auto !important;
    right: auto !important;
    bottom: 0.2rem !important;
    left: 0.2rem !important;
    font-size: 0.16rem !important;
    color: rgba(0, 0, 0, 0) !important;
  }
  .close:before {
    content: '取消';
    color: #fff !important;
    font-size: 0.16rem !important;
  }
  .modal {
    background: #fff !important;
    z-index: 2002;
  }
  .modal:before {
    content: '' !important;
    display: block !important;
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: #000 !important;
    opacity: 0.69 !important;
  }
  .cropper-bg {
    background-image: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityCenter.vue